import { render, staticRenderFns } from "./MyDocumentsPage.vue?vue&type=template&id=075f3b11&scoped=true&"
import script from "./MyDocumentsPage.vue?vue&type=script&lang=ts&"
export * from "./MyDocumentsPage.vue?vue&type=script&lang=ts&"
import style0 from "./MyDocumentsPage.vue?vue&type=style&index=0&id=075f3b11&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075f3b11",
  null
  
)

export default component.exports